import type { Store } from 'store/types';
import { GlobalEvents } from './global-constants';
import { GlobalState } from './global-types';

const INITIAL_STATE: GlobalState = {
  orchestratorHost: '',
  useCredentials: true,
  requestID: '',
  isBot: false,
  userAgent: '',
};

const globalParams = (store: Store) => {
  store.on('@init', state => ({ ...state, ...INITIAL_STATE }));

  store.on(GlobalEvents.setRequestParams, (state, payload) => ({ ...state, ...payload }));

  store.on(GlobalEvents.setRequestID, (state, { requestID }) => ({ ...state, requestID }));

  store.on(GlobalEvents.setIsBot, (state, next) => ({
    ...state,
    isBot: next,
  }));

  store.on(GlobalEvents.setUserAgent, (state, userAgent) => ({ ...state, userAgent }));
};

export const globalState = [globalParams];
